import { render, staticRenderFns } from "./common.vue.pug?vue&type=template&id=12942cad&lang=pug&"
import script from "./common.vue.js?vue&type=script&lang=js&"
export * from "./common.vue.js?vue&type=script&lang=js&"
import style0 from "./common.vue.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports